import * as React from 'react';
import { cn } from '@/utils/cn';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

/**
 * Textarea Component
 *
 * A styled textarea component built on top of the native textarea element.
 * Supports all standard HTML textarea attributes and integrates with the design system.
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      className={cn(
        // Base layout and visual styles
        'flex min-h-[40px] w-full rounded-md border border-gray-300 bg-white px-3 py-2',
        'text-sm text-black ring-offset-background placeholder:text-gray-500',
        // Interaction states (Using numeric token accent-300)
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-300 focus-visible:ring-offset-2',
        // Disabled state
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
